﻿import { useEffect } from 'react'
import { connect } from 'react-redux'

//utils
import { getEpiData } from '../../../../Utils/epiHelpers'

//state 
import { fetchQuestionsData } from '../../State/actions'

// components
import Form from './Form'
import Modal from '../Wizard/Modal'
import FormHero from './FormHero';
import FormHeader from './FormHeader'
import ProgressBar from '../Wizard/ProgressBar'
import HeartLoaderModal from '../../../../UI/HeartLoaderModal'

const FormContainer = (props) => {

    // get data
    useEffect(() => {
        props.loadQuestions();
    }, [])

    const totalQuestions = 22
    const increment = 100 / totalQuestions

    const url = getEpiData('sign-url', props.mountRootId) || ''

    return (
        <div className="pension-wizard-block">
            <FormHeader />
            <ProgressBar />
            <FormHero />

            {props.loading && <HeartLoaderModal />}
            {props.stop && <Modal />}

            <Form
                url={url}
                increment={increment}
                questions={props.questions}
                chapters={props.chapters}
            />
         </div>
    )
}

// state

const mapStateToProps = (state) => {
    return {
        stop: state.pensionWizardFlow.stop,
        loading: state.pensionWizardFlow.loading,
        chapters: state.pensionWizard.chapters,
        questions: state.pensionWizard.questions,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadQuestions: (questionsData) => dispatch(fetchQuestionsData(questionsData)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);

